import { RDEqipFieldsSelection } from '@cibo/core'
import { NotFound, ResourceDetailFeatureTaskEditorProps, Section } from '@cibo/ui'
import { Skeleton, Stack } from '@mui/material'
import { FieldsSelectionList } from '../../../components/FieldsSelection'
import { FieldsSelectionV2 } from '../../../components/FieldsSelection/V2'
import { PracticeSelectionSummaryTable } from '../../../components/PracticeSelectionConfirmation'
import { useProgramEngagementDetails } from '../../../queries'

export const FieldsSelectionFeatureTaskEditor = (
  props: ResourceDetailFeatureTaskEditorProps<RDEqipFieldsSelection>
) => {
  const intendedPractices = useProgramEngagementDetails({
    detailRequirements: [{ traitId: 'eqipRecommendedPracticesIntent', dataType: 'workflow' }],
    engagementId: props.engagementId,
  })
  const goalPractices = useProgramEngagementDetails({
    detailRequirements: [{ traitId: 'eqipPrimaryPractices', dataType: 'workflow' }],
    engagementId: props.engagementId,
  })

  if (intendedPractices.isLoading || goalPractices.isLoading) {
    return (
      <Stack spacing={2}>
        <Skeleton variant="rectangular" width="100%" height={400} />
        <Skeleton variant="rectangular" width="100%" height={500} />
      </Stack>
    )
  }

  if (intendedPractices.isError && goalPractices.isError) {
    return <NotFound />
  }

  if (!intendedPractices.data?.length && !!goalPractices.data?.length) {
    return <FieldsSelectionV2 {...props} />
  } else if (!!intendedPractices.data?.length && !goalPractices.data?.length) {
    return (
      <Stack spacing={2} flex={1}>
        <FieldsSelectionList {...props} />
        <Section>
          <PracticeSelectionSummaryTable {...props} />
        </Section>
      </Stack>
    )
  } else {
    return <NotFound />
  }
}
